module.exports = __webpack_public_path__ + "assets/integration.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integration.png
// module id = 1664
// module chunks = 7